import { z } from "zod";
import { accountOverridesRequestSchema } from "../accounting/account-override.schema";

export const updateInvoiceLineItemBodySchema = z
    .object({
        classIds: z.array(z.string().uuid()).optional(),
        accountOverrides: accountOverridesRequestSchema.optional(),
        accountsReceivableOverrides: accountOverridesRequestSchema.optional(),
        // Transitional legacy fields. New callers should use the
        // per-ledger override arrays; these resolve to the entity's
        // primary accrual ledger server-side.
        accountId: z.string().uuid().nullable().optional(),
        accountsReceivableId: z.string().uuid().nullable().optional(),
    })
    .refine(
        ({
            classIds,
            accountOverrides,
            accountsReceivableOverrides,
            accountId,
            accountsReceivableId,
        }) =>
            classIds !== undefined ||
            accountOverrides !== undefined ||
            accountsReceivableOverrides !== undefined ||
            accountId !== undefined ||
            accountsReceivableId !== undefined,
        {
            message:
                "classIds, accountOverrides, accountsReceivableOverrides, accountId or accountsReceivableId must be provided",
        },
    );
